module.exports = __webpack_public_path__ + "media/img/apple-icon-57x57-815d800a9fec4d6660988c3ad4bed9a5.png";